import { useLocation } from 'react-router-dom'

export const useQuery = () => {
  const location = useLocation()
  return {query: new URLSearchParams(location.search), location}
}
